import type { CommitHistoryEntry } from "~/branching/model/commit-history-entry";

/** Fields read from listTags history rows (HTTP + in-memory). */
export type CommitHistoryRevisionSource = {
  id: string;
  snapshotId: string;
  created?: string | Date | null;
  message?: string | null;
  createdById?: string | null;
};

/** Head-relative projection (isCurrent) is the caller's responsibility. */
export function toCommitHistoryEntries(revisions: CommitHistoryRevisionSource[]): CommitHistoryEntry[] {
  return revisions.map((revision) => ({
    id: revision.id,
    snapshotId: revision.snapshotId,
    createdAt: revision.created ? new Date(revision.created) : null,
    message: revision.message ?? null,
    createdById: revision.createdById ?? null,
  }));
}
